export default __webpack_public_path__ + "poor-signal-icon.png";